// GENERATED FILE - DO NOT MODIFY
export enum SynchronizationTarget {
    Procore = 0,
    Maestro = 1,
}

export let nameof = "SynchronizationTarget";
